import React from "react";
import { organisationStore } from "features/Organisation/OrganisationStore";
import { observer } from "mobx-react-lite";
import OrganisationMenu from "./OrganisationMenu";
import { localStorageKeys } from "utils";
import { sidebarMenuStore } from "../SidebarMenuStore";
import clsx from "clsx";
import NoOrganisationView from "../components/NoOrganisationView";
import OrganisationContent from "../components/OrganisationContent";
import { buildingStore } from "store/Building/BuildingStore";

const CurrentOrganisation = (props: { containerClassName?: string }) => {
  const {
    currentOrgBuildings: buildings,
    currentOrganisation: defaultOrganisation,
  } = sidebarMenuStore;
  const assetLicense = sidebarMenuStore.hasOrganisationAssetLicense();

  async function checkDefaultOrganisation() {
    if (sidebarMenuStore.currentOrganisation) return;
    const savedOrgId = localStorage.getItem(
      localStorageKeys.DEFAULT_ORGANISATION_KEY
    );

    if (!savedOrgId) {
      setFirstOrgAsDefault();
      return;
    }

    const matchingOrg = organisationStore.organisations.items.find(
      (org) => org.id === savedOrgId
    );

    if (matchingOrg) {
      sidebarMenuStore.setCurrentOrganisation(matchingOrg);
    } else {
      setFirstOrgAsDefault();
    }
    await sidebarMenuStore.getCurrentOrgBuildings();
  }

  function setFirstOrgAsDefault() {
    const firstOrg = organisationStore.organisations.items[0];
    localStorage.setItem(
      localStorageKeys.DEFAULT_ORGANISATION_KEY,
      firstOrg.id
    );
    sidebarMenuStore.setCurrentOrganisation(firstOrg);
  }

  React.useEffect(() => {
    if (organisationStore.organisations.items.length === 0) return;
    (async () => await checkDefaultOrganisation())();
  }, [organisationStore.organisations.items.length]);

  if (!defaultOrganisation)
    return (
      <NoOrganisationView
        className={
          buildingStore.sharedBuildings.items.length === 0 ? "border-t" : ""
        }
      />
    );
  return (
    <div
      className={clsx(
        "flex flex-grow flex-col h-full",
        props.containerClassName
      )}
    >
      <OrganisationMenu buildingsCount={buildings.count} />
      <OrganisationContent
        licenseType={sidebarMenuStore.getCurrentLicense()}
        isAsset={assetLicense}
        organisation={defaultOrganisation}
        buildings={buildings}
      />
    </div>
  );
};

export default React.memo(observer(CurrentOrganisation));
